import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addExpenseClaim = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Expense Claim Type',
    body
  );
  return data;
});
export const updateExpenseClaim = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Expense Claim Type/${id}`,
    body
  );
  return data;
});

export const getExpenseClaim = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Expense Claim Type'
  );
  return data;
});
export const deleteExpenseClaim = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Expense Claim Type/${record}`
  );
  return data;
});
export const getExpenseClaimDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Expense Claim Type/${id}`
  );
  return data;
});